export default __webpack_public_path__ + "static/media/free-extensions-icon.9b9771fa.svg";